import styled, { css } from "styled-components";

const BonusItemWrapper = styled.div`
	display: flex;
	padding: 5px 0px;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	align-self: stretch;
	border-radius: 15px;
	background: var(--input-bg-has-value);
	width: 100%;
	margin-bottom: 10px;
	width: 100%;
`;

const ItemHeader = styled.div`
	display: flex;
	padding: 5px 10px;
	justify-content: center;
	align-items: center;
	align-self: stretch;
	background: var(--main-explosive-gradient-020);
	color: #f7f7fc;
	font-size: 10px;
	line-height: 12px;
	letter-spacing: 0.3px;
	border-radius: 15px 15px 0px 0px;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 14px;
	}
`;

const ItemContent = styled.div`
	display: flex;
	height: 40px;
	padding: 5px 10px;
	justify-content: space-between;
	align-items: center;
	align-self: stretch;
	background: var(--main-explosive-gradient-020);
	flex: 1 0 0;
`;

const ContentInfo = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	color: #f7f7fc;
	font-size: 10px;
	line-height: 12px;
	letter-spacing: 0.3px;
	flex: 1;

	@media (min-width: 768px) {
		font-size: 12px;
	}

	&:first-of-type {
		justify-content: flex-start;
	}

	&:last-of-type {
		justify-content: flex-end;
	}
`;

const InfoTitle = styled.div`
	color: #f7f7fc;
	font-size: 12px;
	font-weight: 600;
	line-height: 20px;
	letter-spacing: 0.3px;
`;

const Info = styled.div`
	color: #f7f7fc;
	font-size: 14px;
	font-weight: 700;
	line-height: 20px;
	letter-spacing: 0.3px;
	padding-left: 3px;

	@media (min-width: 768px) {
		font-size: 16px;
	}
`;

const WagerInfo = styled.div`
	display: flex;
	height: 20px;
	justify-content: center;
	align-items: center;
	gap: 12px;
	border-radius: 50px;
	background: #6e7191;
	color: #fcfcfc;
	font-size: 10px;
	font-weight: 600;
	line-height: 12px;
	letter-spacing: 0.3px;
	width: 55px;
	max-width: 55px;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 20px;
	}
`;

const DetailsButton = styled.div`
	display: flex;
	width: 100%;
	justify-content: center;
	align-items: center;
	border-top: 1px solid var(--header-color);
	padding-top: 5px;
	cursor: pointer;
	svg {
		width: 14px;
		height: 14px;
		path {
			stroke: var(--header-color);
		}
	}

	${({ rotate }) =>
		rotate &&
		css`
			svg {
				transform: rotate(180deg);
				animation: rotate 0.1s;
			}
		`}
`;

const ButtonText = styled.div`
	display: flex;
	color: var(--header-color);
	text-align: center;
	font-size: 10px;
	font-weight: 400;
	line-height: 12px;
	letter-spacing: 0.3px;
	min-width: 42px;
	justify-content: flex-end;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 20px;
	}
`;

const DateWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
	padding: 10px;
	justify-content: center;
	align-self: stretch;
	width: 100%;
`;

const Date = styled.div`
	align-items: center;
	display: flex;
	flex: 1 0 0;
	color: #a0a3bd;
	text-align: center;
	font-size: 10px;
	font-weight: 600;
	line-height: 12px;
	letter-spacing: 0.3px;
	justify-content: center;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 20px;
	}
`;

const Detail = styled.div`
	display: flex;
	padding: 10px;
	align-items: center;
	gap: 10px;
	align-self: stretch;
	color: var(--main-color);
	text-align: center;
	font-size: 10px;
	font-weight: 400;
	line-height: 12px;
	letter-spacing: 0.3px;
	justify-content: center;

	@media (min-width: 768px) {
		font-size: 12px;
	}
`;

const DetailWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
	justify-content: center;
`;

export {
	BonusItemWrapper,
	ButtonText,
	ContentInfo,
	Date,
	DateWrapper,
	Detail,
	DetailWrapper,
	DetailsButton,
	Info,
	InfoTitle,
	ItemContent,
	ItemHeader,
	WagerInfo,
};
